<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('gameBetting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('gameBetting.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{
            $t('gameBetting.startBetting')
            }}
          </ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="visible = false"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">
                  {{
                  $t('gameBetting.gameType')
                  }}
                </label>
                <a-select 
                  class="ts-w-full"
                  mode="multiple" 
                  v-model="gameTypeId"
                >
                  <a-select-option :value="1">6/49</a-select-option>
                  <a-select-option :value="2">5D</a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('gameBetting.date') }}</label>
                <a-date-picker
                  v-model="dateNow"
                  format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  class="ts-w-full"
                />
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading" :expandable="true">
        <template v-slot="{ record }">
          <td>{{ record.dealer.dealer_name }}</td>
          <td>{{ record.betting_no }}</td>
          <td>{{ record.betting_time }}</td>
          <td class="text-center ts-whitespace-no-wrap">
            <a
              v-tooltip="$t('delete')"
              href="#"
              @click.prevent="deleteRecord(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fa fa-trash text-red" v-else></i>
            </a>
          </td>
        </template>
        <template v-slot:expand="{ record }">
          <table class="ts-w-6/12 ts-mx-auto">
            <tr>
              <td style="border:none">{{ $t('gameBetting.pickupNumber') }}</td>
              <td style="border:none">{{ $t('gameBetting.bettingAmount') }}</td>
              <td style="border:none">{{ $t('gameBetting.user') }}</td>
              <td style="border:none" class="ts-text-center">{{ $t('actions') }}</td>
            </tr>
            <tr v-for="(data, index) in record.game_bettings" :key="index">
              <td>
                <ul class="number-list ts-flex ts-space-x-2 ts-my-auto">
                  <li
                    v-for="(result, index) in spliteString(data.picked_number)"
                    :key="index"
                    class="ts-leading-8 ts-font-robot ts-rounded-full ts-text-center ts-text-heading-color ts-border ts-border-gray-500 ts-text-base ts-inline-block ts-h-8 ts-w-8"
                  >{{ result }}</li>
                </ul>
              </td>
              <td>{{ data.total_betting_amount }}</td>
              <td>{{ data.user.name }}</td>
              <td class="ts-text-center">
                <a
                  href="#"
                  class="ts-mr-2 ts-ml-2"
                  v-if="data.game_set.game_setting.game_type_id == 2"
                  @click.prevent="view(data)"
                >
                  <i class="fas fa-eye" v-tooltip="$t('view')"></i>
                </a>
                <i class="fas fa-eye-slash" v-else></i>
              </td>
            </tr>
          </table>
        </template>
      </ts-table>
      <!-- <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'dealer.dealer_name'
        }"
      >
        <template v-slot="{ record }">
          <td valign="middle">{{ record.betting_no }}</td>
          <td valign="middle">{{ record.betting_time }}</td>
          <td>
            <ul class="number-list ts-flex ts-space-x-2 ts-my-auto">
              <li
                v-for="(result, index) in spliteString(record.picked_number)"
                :key="index"
                class="ts-leading-8 ts-font-robot ts-rounded-full ts-text-center ts-text-heading-color ts-border ts-border-gray-500 ts-text-base ts-inline-block ts-h-8 ts-w-8"
              >
                {{ result }}
              </li>
            </ul>
          </td>
          <td>
            <span class="ts-font-semibold ts-text-heading-color">{{
              record.total_betting_amount
            }}</span>
          </td>
          <td class="ts-whitespace-no-wrap">
            {{ record.user.name }}
          </td>
          <td class="text-center ts-whitespace-no-wrap">
            <a
              href="#"
              class="ts-mr-2 ts-ml-2"
              v-if="record.game_set.game_setting.game_type_id == 2"
              @click.prevent="view(record)"
              ><i class="fas fa-eye" v-tooltip="$t('view')"></i
            ></a>
            <a
              v-tooltip="$t('delete')"
              href="#"
              @click.prevent="deleteRecord(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fa fa-trash text-red" v-else></i>
            </a>
          </td>
        </template>
        <template v-slot:tfooter v-if="resources.length > 0">
          <tfoot>
            <tr>
              <td colspan="3" class="ts-text-right">
                <span
                  class="ts-text-heading-color ts-uppercase ts-font-semibold"
                  >total :
                </span>
              </td>
              <td
                colspan="3"
                class="ts-text-red-700 ts-font-heading-font ts-font-semibold"
              >
                {{ totalAmount }}
              </td>
            </tr>
          </tfoot>
        </template>
      </ts-table>-->
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
      <a-modal v-model="view_detail" :title="$t('view')" centered :zIndex="1020" :footer="null">
        <table class="ts-w-full" border="1">
          <thead>
            <tr>
              <th class="ts-border-b ts-border-gray-200 ts-py-3">{{ $t('gameBetting.lotName') }}</th>
              <th class="ts-border-b ts-border-gray-200 ts-py-3">{{ $t('gameBetting.betNumber') }}</th>
              <th class="ts-border-b ts-border-gray-200 ts-py-3">{{ $t('gameBetting.amount') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in detail_resource" :key="index">
              <td class="ts-py-3 ts-border-b ts-border-gray-200">{{ detail.game_lot_name }}</td>
              <td class="ts-py-3 ts-border-b ts-border-gray-200">{{ detail.picked_number }}</td>
              <td class="ts-py-3 ts-border-b ts-border-gray-200">{{ detail.betting_amount }}</td>
            </tr>
          </tbody>
        </table>
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import Reason from './components/reason_delete'
import moment from 'moment'

export default {
  name: 'gameBetting',
  data() {
    return {
      visible: false,
      loading: false,
      view_detail: false,
      detail_resource: [],
      errors: new Errors(),
      model: {
        deleted_comment: null
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('game/gameBetting', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.game.gameBetting.search
      },
      set(newValue) {
        this.$store.commit('game/gameBetting/SET_SEARCH', newValue)
        this.$store.commit('game/gameBetting/RESET_CURRENT_PAGE')
      }
    },
    gameTypeId: {
      get() {
        return this.$store.state.game.gameBetting.game_type_id
      },
      set(newValue) {
        this.$store.commit('game/gameBetting/SET_GAME_TYPE', newValue)
      }
    },
    dateNow: {
      get() {
        return this.$store.state.game.gameBetting.date_now
      },
      set(newValue) {
        this.$store.commit(
          'game/gameBetting/SET_DATE',
          newValue
        )
      }
    },
    totalAmount() {
      return _.sumBy(this.resources, 'total_betting_amount')
    },
    totalWinAmount() {
      return _.sumBy(this.resources, 'win_amount')
    },
    columns() {
      return [
        { name: this.$t('gameBetting.dealer') },
        { name: this.$t('gameBetting.invoiceNum') },
        { name: this.$t('gameBetting.dateTime') },
        { name: this.$t('actions'), style: 'text-align:center; width:10px' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('game/gameBetting/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.$router.push({ name: 'game-betting-create' })
    },
    view(record) {
      this.detail_resource = _.orderBy(
        record.details.map(el => ({
          game_lot_name: el.game_lot.game_lot_name,
          picked_number: el.picked_number,
          betting_amount: el.betting_amount,
          odds: el.odds
        })),
        ['game_lot_name'],
        ['asc']
      )
      this.view_detail = true
    },
    spliteString(value) {
      return value.split(',')
    },
    deleteRecord(record) {
      this.model.deleted_comment = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('gameBetting.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch('game/gameBetting/destroy', {
              id: record.ticket_number,
              data: this.model
            })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    gameTypeId: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    dateNow: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('game/gameBetting/RESET_STATE')
    next()
  }
}
</script>
